import { arrayOf, shape, string } from 'prop-types'

export const link = {
  as: string,
  crossOrigin: string,
  href: string,
  hrefLang: string,
  integrity: string,
  media: string,
  referrerPolicy: string,
  rel: string,
  sizes: string,
  title: string,
  type: string,
  disabled: string,
  methods: string,
  prefetch: string,
  target: string,
}

export const meta = {
  itemProp: string,
  charSet: string,
  content: string,
  httpEquiv: string,
  name: string,
  scheme: string,
  property: string,
}

const jsonLd = {
  organization: shape({}).isRequired,
}

export const head = shape({
  metas: arrayOf(shape(meta)).isRequired,
  links: arrayOf(shape(link)).isRequired,
  jsonLd: shape(jsonLd).isRequired,
  scriptsEnabled: shape({}),
})
